import * as React from 'react'

function IconHere(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={48}
      height={63}
      viewBox="0 0 48 63"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M23.625 0C10.578 0 0 10.792 0 24.103 0 36.73 10.384 51.515 17.384 60.04a7.99 7.99 0 0012.43-.018c6.999-8.616 17.436-23.545 17.436-35.92C47.25 10.793 36.672 0 23.625 0z"
        fill="#E84E25"
      />
      <circle cx={23.625} cy={25.2} r={9.45} stroke="#fff" strokeWidth={3} />
    </svg>
  )
}

export default IconHere
